var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "pb-10 mangerRequests bg-white px-8 py-6" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            hasData: !!_vm.requests,
            loading: _vm.$apollo.queries.requests.loading,
          },
        },
        [
          _vm.isEmpty
            ? _c("EmptyListPlaceholder", {
                attrs: { title: _vm.emptyListTitle },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageRequests")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2557147869
                ),
              })
            : _c("div", {}, [
                _c("div", [
                  _c(
                    "span",
                    {
                      staticClass:
                        "flex font-400 labelWidth leading-6 mb-4 text-primary-black",
                    },
                    [
                      _vm._v(" Current requests "),
                      _vm.requests && _vm.requests.length > 0
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "text-gray-new text-base font-normal text-sm ml-0.5",
                            },
                            [_vm._v("(" + _vm._s(_vm.requests.length) + ")")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "table-container" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "relative w-full text-sm font-normal text-left dark:text-gray-400",
                    },
                    [
                      _c(
                        "thead",
                        {
                          staticClass:
                            "text-m text-black font-normal bg-light-green customBackground",
                        },
                        [
                          _c("tr", { staticClass: "font-normal" }, [
                            _c(
                              "th",
                              {
                                staticClass: "text-sm py-4 pl-4 w-30 relative",
                                staticStyle: { width: "14%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" Company status "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-sm py-4 w-28 relative",
                                staticStyle: { width: "13%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" Name "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "py-4 text-sm w-48 relative",
                                staticStyle: { width: "13%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" Location "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "py-4 text-sm w-36 relative",
                                staticStyle: { width: "10%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" Title "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "py-4 text-sm w-36 relative",
                                staticStyle: { width: "9%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" Rate "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "py-4 text-sm w-44 relative",
                                staticStyle: { width: "13%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" Skills required "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "py-4 text-sm w-36 relative",
                                staticStyle: { width: "15%" },
                                attrs: { scope: "col" },
                              },
                              [
                                _vm._v(" ProveraCare Profile "),
                                _c("span", {
                                  staticClass:
                                    "right-border px-4 absolute right-4",
                                }),
                              ]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "px-2 py-4 text-sm w-40",
                                staticStyle: { width: "10%" },
                                attrs: { scope: "col" },
                              },
                              [_vm._v(" Requested On ")]
                            ),
                            _c("th", {
                              staticClass: "px-2 py-2 text-sm w-10",
                              staticStyle: { width: "5%" },
                              attrs: { scope: "col" },
                            }),
                          ]),
                        ]
                      ),
                      _vm._l(_vm.requests, function (request) {
                        return _c("RequestCard", {
                          key: request.id,
                          attrs: {
                            contractorUser: request.contractor.user,
                            managerUser: request.manager.user,
                            requestId: request.id,
                            contractorId: request.contractor.id,
                            managerId: request.manager.id,
                            contractorApproved: request.contractor.approved,
                            currentUserRole: _vm.currentUserRole,
                            requestDate: request.created_at,
                          },
                          on: { refetch: _vm.refetchRequests },
                        })
                      }),
                    ],
                    2
                  ),
                ]),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }